import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  BaseSiteService,
  CmsService,
  GlobalMessageService,
  LanguageService,
  OccEndpointsService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomAddToCartService } from 'src/app/custom-add-to-cart/custom-add-to-cart.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from 'src/app/shared/utils/common.utils';
import * as _ from 'underscore';
import {
  NumberSix,
  NumberTen,
  NumberThree,
} from '../../../app/shared/utils/constants/global.constants';
import { CheckoutService } from '../../shared/modules/checkout/checkout.service';
import { CustomInfluenzaService } from '../custom-influenza.service';
import { ProductDetailsInfluenzaComponent } from '../product-details-influenza/product-details-influenza.component';
@Component({
  selector: 'app-order-confirm-flu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './order-confirm-flu.component.html',
  styleUrls: ['./order-confirm-flu.component.scss'],
})
export class OrderConfirmFluComponent implements OnInit {
  delHrs = [
    {
      day: 'MONDAY',
      fromTime: '4:00 am',
      toTime: '1:00 pm',
    },
    {
      day: 'TUESDAY',
      fromTime: '24 hours',
    },
    {
      day: 'WEDNESDAY',
      fromTime: '24 hours',
    },
    {
      day: 'THURSDAY',
      fromTime: '24 hours',
    },
    {
      day: 'FRIDAY',
      fromTime: '24 hours',
    },
  ];
  editDeliveryHrs = false;
  ContactnameEdited: boolean = false;
  POnameEdited: boolean = false;
  inValid: boolean = false;
  // @ViewChild('s3') public viewSavingsPopover: NgbPopover;
  // @ViewChild(NgbPopover) popover:NgbPopover;
  @ViewChildren(NgbPopover) popovers: QueryList<NgbPopover>;
  @ViewChild('reservationContactSpan') reservationContact;
  contactDetails: any;
  userAccountDetailsSub: any;
  totalUnits = 1;
  productEntriesNewDoses: any;
  dataForPlaceOrder: any;
  totalDisCount: any;
  fluLocatorDetail: any;
  totalWithPromptDis: any;
  addnewEmailClicked: boolean = false;
  contactmethod: boolean = false;
  totalDoses = 5;
  newemail: boolean = false;
  emailArr = [];
  cmsResponse: any;
  imageUrl: any;
  emailMobile = [];
  removeGrid: boolean = false;
  cartItemsSub: Subscription;
  cartProdDetails: Subscription;
  noshowaddemail: boolean = false;
  noshowaddmobile: boolean = false;
  b2b: any;
  b2bUnitID: any;
  contentModule = 'reserveContact';
  editContact: boolean = false;
  editPo: boolean = false;
  // estimatedTotal:number=0;
  estimatedSavings: number = 0;
  subTotal: number = 0;
  exciseTax: number = 0;
  salesTax: number = 0;
  onlineSavings: number = 0;
  directSavings: number = 0;
  totalWithoutPromptDisc: number = 0;
  promptPayDiscount: number = 0;
  promptPayDiscTemp: number = 0;
  totalWithoutSavings: number = 0;
  // amountDetails = {
  //   'subTotal': '1000',
  //   'exciseTax': '37.5',
  //   'onlineSavings': '6.5',
  //   'total': '1031.5',
  //   'promptPayDisc': '0',
  //   'totalWithPromptPay': '1031.5'
  // }

  isSticky: boolean = false;

  baseUrl: any;
  fluProductsList = [];
  screenwidth: any;
  userData: any = [];

  userDataSub: Subscription;
  activeSeasonSub: Subscription;
  fluProductsSubs: Subscription;
  activeSeasonId: string = '2022-2023';
  header: any = 'VerifyPayment';

  isUpdated: boolean = true; //on reaching verify payment page, data is updated only
  hidePaymentMethod: boolean = false;
  langSelected: string;

  selectedPaymentMethodDetails: any;
  selectedCardOrAccountDetails: any;
  poNumber: string = '';
  attention: string = '';
  specialInstruction: string = '';
  promptDiscount: any;
  freightProduct = false;
  public images: any;
  productEntries: any = [];

  checkoutRes: any = [];

  fallbackImage = '../../../assets/img/missing_product_EN_300x300.jpg';
  getCartsApiSubscriber: Subscription;
  parentCartId: any;
  cartCheckoutSub: Subscription;
  totalInfluenzaProducts: number = 0;
  totalInfluenzaDoses: number = 0;
  productsForExcel: any[];
  standardCartDetails: any;
  selectedData: any;
  getuserData: any;
  userAccountgetData: any;
  pdfUrl: any;
  activeSeasonSubscriber: Subscription;
  userAccountDetailsSubscriber: Subscription;
  emailFinalArr: any = [];
  mobFinalArr: any = [];
  childCarts: any = [];
  phoneNo: string = '';
  deliveryDate: any = '';

  baseSiteId: string;

  //Edit variables:
  reservationNo: string = ''; //to be blank initially -VO6735562
  reservationStatus: string = ''; //to be blank initially, values- Confirmed, Partially Confirmed, Not Confirmed
  editReservation: boolean = false; //to be false initially
  cancelReservation: boolean = false; //to be false initially
  decreasedQtyOnEdit = false;
  decreaseOnEditOrCancelLink = 'reduction'; //other value - cancellation
  decreaseOnEditOrCancelTitle = 'reducing';
  currentPopover: NgbPopover;

  totalWithPromptDisc: number = 0;
  totalInfluenzaProductsBackend: number = 0;
  totalInfluenzaDosesBackend: number = 0;

  requestedDelDate = '';

  cancellationReasons = []; //to be empty array initially
  cardDetails: string = '';

  isConfirmSuccOpen = true;
  contactDetailsSub: Subscription;
  jointResponse: any;
  closeConfirmBanner() {
    this.isConfirmSuccOpen = false;
  }

  reservationDetailsEntries: any = [];
  reservationDetailsProducts: any = [];
  shipDelDate = '';
  shippingAddressOfLocation: any = {};
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  selectedLocation: string = '';
  placeOrderSub: Subscription;

  constructor(
    private readonly influenzaService: CustomInfluenzaService,
    private readonly checkoutService: CheckoutService,
    private readonly globalMessage: GlobalMessageService,
    private readonly addToCart: CustomAddToCartService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly sharedService: SharedService,
    private readonly modalService: NgbModal,
    private readonly occEndPoint: OccEndpointsService,
    private readonly cmsData: CmsService,
    private readonly translation: TranslationService,
    private readonly lang: LanguageService,
    private readonly baseService: BaseService,
    private fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly csAgentAuthService: CsAgentAuthService,
    private baseSiteService: BaseSiteService,
    private _dataService: DataLayerService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  contactForm: FormGroup = this.fb.group({
    poName: ['', Validators.required],
    name: [''],
    email: [''],
    fax: [''],
  });

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    if (window.pageYOffset >= 300) {
      //580
      this.isSticky = true; //should be true
      // this.popovers.forEach(popover => {
      //   if (popover.isOpen() && !popover?.popoverClass.includes('expirysixmonths-popover')) {
      //     popover.close();
      //   }
      // })
    } else {
      this.isSticky = false;
    }

    // if(this.popover?.isOpen()){
    //     this.popover.close();
    // }
  }

  checkForEditReservation() {
    this.editReservation = this.route.snapshot.queryParams.editReservation
      ? true
      : false;
    this.cancelReservation = this.route.snapshot.queryParams.cancelReservation
      ? true
      : false;
    this.reservationNo = this.route.snapshot.queryParams.orderNo
      ? this.route.snapshot.queryParams.orderNo
      : '';
    this.ref.detectChanges();
    if (this.editReservation || this.cancelReservation) {
      //if condition added
      this.influenzaService.endFluJourneyTimer(); //added for safety, although its happening on verify payment relaese lock
      this.getCancellationReductionReasons(); // Need to change it from select vaccine instead of api call
    }
  }

  getCancellationReductionReasons() {
    this.influenzaService
      .getEditCancelReductionReasons({
        enumerationType: 'ReductionReasons',
        fields: 'DEFAULT',
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res != null && res !== undefined && res?.length > 0) {
          this.cancellationReasons = res;
        }
      });
  }

  ngOnInit(): void {
    this.cmsData
      .getComponentData('FluLocatorMapBannerComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
        this.imageUrl = this.baseUrl + this.cmsResponse.media.url;
        if (this.cmsResponse?.media?.url) {
          this._dataService.addtoDataLayer('view_promotion', this.cmsResponse);
        }
      });

    this.csAgentAuthSubscription = this.csAgentAuthService
      .isCustomerEmulated()
      .subscribe((res) => {
        this.isAsmUser = res ? res : false;
      });
    this.jointResponse = this.sharedService.getSessionStorage('fluData');

    //1. checking if normal or edit reservation or cancel reservation
    this.checkForEditReservation();

    //2. Setting the activeSeasonId to be shown on UI
    const seasonID = this.sharedService.getSessionStorage('activeSeasons');
    if (seasonID) {
      this.activeSeasonId = seasonID;
    } else {
      this.activeSeasonSubscriber =
        this.influenzaService.activeSeaons.subscribe((response) => {
          if (response) {
            response?.categoryData?.forEach((season) => {
              if (season['defaultSeason']) {
                this.activeSeasonId = season['code'];
              }
            });
            if (
              this.activeSeasonId === undefined ||
              this.activeSeasonId === null
            ) {
              this.activeSeasonId = response?.categoryData?.[0]?.code; //assigning 1st index as the last resort
            }
            this.activeSeasonSubscriber?.unsubscribe();
            this.ref.detectChanges();
          }
        });
    }
    //3. Setting the baseSiteID - vsh or vax
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));

    this.emailArr = [{ id: null, value: '' }];
    this.emailMobile = [{ id: null, value: '' }];

    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userData = res;
        this.getOrderData(this.userData.uid);
        //this api to be called with selected location and not with default b2b
        this.influenzaService.getFluLocatorDetailsReservation(
          this.userData.uid,
          this.getB2BUid(),
          this.reservationNo
        );
        this.userDataSub?.unsubscribe();
      }

      // this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      //   this.b2bUnitID = res?.defaultB2BUnit?.uid;
      //   const params = {
      //     b2bUnitId: this.b2bUnitID,
      //   };
      //   this.influenzaService.getFluLocatorDetailsReservation(this.userData.uid, this.b2bUnitID, this.reservationNo);
      // });
    });
    this.influenzaService.fluLocatorDetailsReservation.subscribe((resp) => {
      this.fluLocatorDetail = resp;
      this.fluLocatorDetail?.fluLocators?.forEach((el) => {
        var optedIdId = el?.materialsOptedIn?.split(',');
        if (optedIdId?.length > 0) {
          el.optedInId = optedIdId[0];
        }
      });
    });

    this.ref.detectChanges();
  }

  ngAfterViewInit() {
    this.reservationContact.nativeElement.click();
  }

  submitenrollment() {
    this.SaveAction();
  }

  SaveAction() {
    // var obj = {};
    // var arr = this.dataSetForEdit.fullName.split(" ");
    //var explodedState = typeof (this.fluLocatorDetail?.fluLocators.state) === 'object' ? this.dataSetForEdit.state.isocode.split("-") : this.dataSetForEdit.state.split("-");
    this.removeGrid = false;
    var arrForTotalSet = [];

    //var arr = this.dataSetForEdit.fullName.split(" ");
    var obj = {
      addFluLocation: this.fluLocatorDetail?.fluLocators[0]?.addFluLocation,
      customerName: this.fluLocatorDetail?.fluLocators[0]?.customerName,
      locatorId: this.fluLocatorDetail?.fluLocators[0]?.locatorId,
      address: this.fluLocatorDetail?.fluLocators[0]?.address,
      city: this.fluLocatorDetail?.fluLocators[0]?.city,
      state: this.fluLocatorDetail?.fluLocators[0]?.state,
      zipcode: this.fluLocatorDetail?.fluLocators[0]?.zipcode,
      originalZipcode: this.fluLocatorDetail?.fluLocators[0]?.zipcode,
      phone: this.fluLocatorDetail?.fluLocators[0]?.phone,
      fax: '',
      email: '',
      statusId: this.fluLocatorDetail?.fluLocators[0]?.statusId,
      materialOptoutStatusList:
        this.fluLocatorDetail?.fluLocators[0]?.materialOptoutStatusList,
      //"operId": this.fluLocatorDetail?.fluLocators[0].mdg_num,
      operId: this.fluLocatorDetail?.fluLocators[0]?.operId,
      bypassMaterialEnrollment: 0,
      materialsEnrolled: '',
      materialsOptedIn: '',
      showNotOfferedAlert:
        this.fluLocatorDetail?.fluLocators[0]?.showNotOfferedAlert,
      customerNumber: this.fluLocatorDetail?.fluLocators[0]?.customerNumber,
      sales_org: this.fluLocatorDetail?.fluLocators[0]?.sales_org,
      CSEG: this.fluLocatorDetail?.fluLocators[0]?.CSEG,
      fluZoneOptedIn: this.fluLocatorDetail?.fluLocators[0]?.fluZoneOptedIn,
      fluBlockOptedIn: this.fluLocatorDetail?.fluLocators[0]?.fluBlockOptedIn,
    };

    this.influenzaService.saveFluLocatorDetails(this.userData.uid, obj);
    this.influenzaService.flulocatorDetailsSave.subscribe((res) => {
      if (res.success) {
        //this.globalMessage.add('Reservation contact details updated successfully.', GlobalMessageType.MSG_TYPE_CONFIRMATION);
        // this.router.goByUrl('/vaccineLocatorPage');
        // location.reload();
        this.removeGrid = true;
        this.ref.detectChanges();
      } else {
        this.removeGrid = false;
        this.ref.detectChanges();
        //this.globalMessage.add('Oops! There seems to be some issue there.', GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }
    });
  }

  changeEnrollFlag(id, flg, flgst) {
    this.fluLocatorDetail.fluLocators.forEach((el) => {
      if (el.locatorId == id) {
        if (!flgst) {
          el.statusId = 2;
        } else {
          el.statusId = 1;
        }
      }
    });
  }
  changeOptInFlag(id, flg, newOptinStatus) {
    this.fluLocatorDetail?.fluLocators?.forEach((el) => {
      if (el?.locatorId == id) {
        el[flg] = newOptinStatus;
      }
    });
  }
  redirecttoAccount() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Address(s) of Business Unit(s)');
    this.ref.detectChanges();
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }
  getB2BUid() {
    let b2bUid: string;
    let facilityName: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0]
        ?.accountNumber;
      // facilityName = JSON.parse(sessionStorage.getItem('selectedLocations'))[0]?.facilityName + ' ' + JSON.parse(sessionStorage.getItem('selectedLocations'))[0]?.facilityName2;
      facilityName = JSON.parse(sessionStorage.getItem('selectedLocations'))[0]
        ?.companyName;
      this.selectedLocation = facilityName + ' (' + b2bUid + ')';
    } else {
      //default location
      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0]
        ?.accountNumber;
      // facilityName = JSON.parse(sessionStorage.getItem('defaultLocation'))[0]?.facilityName + ' ' + JSON.parse(sessionStorage.getItem('defaultLocation'))[0]?.facilityName2;
      facilityName = JSON.parse(sessionStorage.getItem('defaultLocation'))[0]
        ?.companyName;
      this.selectedLocation = facilityName + ' (' + b2bUid + ')';
    }
    return b2bUid;
  }

  getOrderData(userName) {
    const b2bUid = this.getB2BUid();

    this.contactDetailsSub = this.addToCart
      .getOrderContactDetails(userName, b2bUid)
      .subscribe((res) => {
        this.contactDetails = res;

        this.emailArr.forEach((el) => {
          el.value = this.contactDetails.contactEmail;
        });
      });

    //so that if confirmation page reloaded, we can still see data on the page.
    const placeOrderRes = this.sharedService.getSessionStorage('fluOrderDtls');
    if (placeOrderRes) {
      this.cartDataMapping(placeOrderRes);
    } else {
      // Main observable to listen to
      this.placeOrderSub = this.influenzaService.placeOrderResp.subscribe(
        (res: any) => {
          if (res) {
            // if (res.orders[0].hasOwnProperty("placeOrderMessage") && (res?.orders[0]?.placeOrderMessage == 'Error while payment authorization during place order.' || res?.orders[0]?.placeOrderMessage == 'Error while payment authorization during edit order.')) {
            //   console.log('confirm-Error while payment authorization');
            //   this.globalMessage.add('Error while payment authorization during place order.', GlobalMessageType.MSG_TYPE_ERROR);
            //   setTimeout(() => {
            //     this.router.goByUrl("/influenza/dashboard");
            //   }, 2000);
            // }
            // else {
            // console.log('confirm-no Error while payment authorization');
            this.sharedService.setSessionStorage('fluOrderDtls', res);
            this.cartDataMapping(res);
            // }
          }
        }
      );
    }
    this.ref.detectChanges();
  }

  calculateEstimatedTotalAndSavings(standardCartDetails: any) {
    if (standardCartDetails) {
      this.subTotal =
        standardCartDetails?.subTotal?.value +
        standardCartDetails?.totalTax?.value;
      this.exciseTax = standardCartDetails?.totalExciseTax?.value;
      this.totalDisCount = standardCartDetails?.totalDiscounts?.value;
      this.promptDiscount = standardCartDetails?.totalPromptPayDiscount?.value;
      this.totalWithPromptDis =
        standardCartDetails?.totalWithPromptPayDiscount?.value;
      //Excise tax has positive value but total tax is still coming 0
      if (standardCartDetails?.totalTax?.value >= this.exciseTax) {
        this.salesTax = standardCartDetails?.totalTax?.value - this.exciseTax;
      }
      this.productEntriesNewDoses = standardCartDetails?.entries;
      this.totalWithoutSavings = this.subTotal + this.exciseTax + this.salesTax;

      const savingsOnline = standardCartDetails?.totalWebDiscount?.value;
      this.onlineSavings = Math.abs(savingsOnline);

      const savingsDirect = standardCartDetails?.totalOtherDiscount?.value;
      this.directSavings = Math.abs(savingsDirect);

      const savingsTotal = this.onlineSavings + this.directSavings;
      //converting -ve to postive
      this.estimatedSavings = Math.abs(savingsTotal);

      this.totalWithoutPromptDisc =
        this.subTotal + this.exciseTax + this.salesTax - this.estimatedSavings;

      //Prompt pay discount is not coming at parent cart level.So calculating it from products
      // this.promptPayDiscount = standardCartDetails?.totalOtherDiscount?.value;

      // this.estimatedTotal = standardCartDetails?.subTotal?.value + standardCartDetails?.exciseTax?.value - this.estimatedSavings;

      this.ref.detectChanges();
    }
  }

  dwnloadAsExcel() {
    this.productsForExcel = [];

    this.productEntries.forEach((entries, index) => {
      this.productsForExcel.push({
        Customer:
          this.standardCartDetails?.shipToParty?.billingAddress?.accountNumber,
        'Material ID': entries?.product?.code,
        Quantity: entries?.quantity,
        'PO Number': this.poNumber,
      });
      if (index + 1 === this.productEntries.length) {
        this.influenzaService.dataForExcel = this.productsForExcel;
      }
      //setting flu as tru to show (influenza vaccines) in product details
      entries.product['flu'] = true;

      //setting cancellation/reduction reason if any
      let changeReason = entries?.cancelReasonCode
        ? entries?.cancelReasonCode
        : entries?.reductionReasonCode;
      entries['chngReason'] = changeReason ? changeReason : '';
      //updating shipnow flag for onsn rules
      // const matchedJoinedResp = this.jointResponse?.find(fluPrdct => fluPrdct?.code === entries?.product?.code && !entries?.hideRow);
      const matchedJoinedResp = this.jointResponse?.find(
        (fluPrdct) =>
          fluPrdct?.code === entries?.product?.code &&
          !(entries?.hideRow && entries?.quantityStatus == 'TBD')
      );
      // if(matchedJoinedResp?.shipNow){
      //   entries.product.shipNow = matchedJoinedResp?.shipNow;
      // }
      if (matchedJoinedResp) {
        entries.product.partOfEarlierReservation =
          matchedJoinedResp?.partOfEarlierReservation;
        if (matchedJoinedResp?.shipNow) {
          entries.product.shipNow = matchedJoinedResp?.shipNow;
        }
      }
    });
    //removing it once its work is done
    this.sharedService.removeSessionStorage('fluData');
    this.ref.detectChanges();
  }

  downloadExcel() {
    this.influenzaService.downloadXls(
      this.influenzaService.dataForExcel,
      'InfluenzaCheckout'
    );
  }

  productDetails(productDetails) {
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, {
      windowClass: `product-details-inf-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails.code;
    modalRef.componentInstance.checkout = true;
  }

  contactmethodValchk(e) {
    this.POnameEdited = true;
    this.newemail = false;
    if (e.target.value == 'fax') {
      this.contactDetails.confirmMethodEmail = false;
      this.contactmethod = true;
      //this.contactDetails.contactEmail = this.contactDetails.arrForEmailRightSide[0];
    } else {
      this.contactDetails.confirmMethodEmail = true;
      this.contactmethod = false;
    }
  }

  addnewemail() {
    this.addnewEmailClicked = true;
    if (this.emailArr.length <= 3) {
      this.emailArr.push({ id: null, value: '' });
      if (this.emailArr.length == 3) {
        this.noshowaddemail = true;
      }
    }
  }

  addnewmobile() {
    this.addnewEmailClicked = true;
    if (this.emailMobile.length <= 3) {
      this.emailMobile.push({ id: null, value: '' });
      if (this.emailMobile.length == 3) {
        this.noshowaddmobile = true;
      }
    }
  }
  cancelAllLocation() {
    this.editContact = false;
  }
  savingDetails() {
    this.editContact = false;
  }

  deleteEmail(i) {
    this.emailArr.splice(i, 1);
    if (this.emailArr.length < 3) {
      this.noshowaddemail = false;
    }
  }

  getPositveNumber(number) {
    if (number != undefined && number != null) {
      return Math.abs(number);
    } else {
      return 0;
    }
  }

  cartDataMapping(data): void {
    this.standardCartDetails = data?.orders[0];
    //UI not expected to do calculations for total prices
    // this.calculateEstimatedTotalAndSavings(this.standardCartDetails);
    this.mapEstimatedTotalAndSavings(this.standardCartDetails);
    this.checkReservationStatus(this.standardCartDetails);
    this.capturePaymentInfo(this.standardCartDetails);
  }

  mapEstimatedTotalAndSavings(standardCartDetails: any) {
    if (standardCartDetails) {
      this.subTotal = standardCartDetails?.subTotal?.value;
      this.exciseTax = standardCartDetails?.totalExciseTax?.value
        ? standardCartDetails?.totalExciseTax?.value
        : 0; // may b not coming in placeorder response

      //calculating salesTax but its not required to show as per discussion
      // if (standardCartDetails?.totalTax?.value >= this.exciseTax) {
      //   this.salesTax = standardCartDetails?.totalTax?.value - this.exciseTax;
      // }
      //now salesTax required to be shown
      this.salesTax = standardCartDetails?.totalSalesTaxPrice?.value
        ? standardCartDetails?.totalSalesTaxPrice?.value
        : 0;

      this.totalWithoutSavings = standardCartDetails?.totalPriceWithTax?.value
        ? standardCartDetails?.totalPriceWithTax?.value
        : 0; //may b not coming in response
      this.onlineSavings = standardCartDetails?.totalWebDiscount?.value
        ? standardCartDetails?.totalWebDiscount?.value
        : -0;
      this.directSavings = standardCartDetails?.totalOtherDiscount?.value
        ? standardCartDetails?.totalOtherDiscount?.value
        : -0;
      this.promptPayDiscount = standardCartDetails?.totalPromptPayDiscount
        ?.value
        ? standardCartDetails?.totalPromptPayDiscount?.value
        : -0;

      this.estimatedSavings = standardCartDetails?.totalDiscounts?.value
        ? standardCartDetails?.totalDiscounts?.value
        : -0;
      //10nov23 - As discussed, prompt pay discount will not be part of total savings returned from backend
      this.estimatedSavings = this.estimatedSavings + this.promptPayDiscount; //since both -ve, should get added

      this.totalWithoutPromptDisc = standardCartDetails?.totalPriceWithTax
        ?.value
        ? standardCartDetails?.totalPriceWithTax?.value
        : 0; //may b not coming in response
      // this.totalWithPromptDisc = standardCartDetails?.totalWithPromptPayDiscount?.value;
      //10Nov23- prompt pay discount will not be part of total price also
      this.totalWithPromptDisc = standardCartDetails?.totalPrice?.value
        ? standardCartDetails?.totalPrice?.value
        : 0;

      this.totalInfluenzaProductsBackend = standardCartDetails?.totalUnitCount;
      this.totalInfluenzaDosesBackend = standardCartDetails?.totalDosesCount;

      // Added ponumber and attention for verify payment
      this.poNumber = standardCartDetails?.purchaseOrderNumber;
      this.attention = standardCartDetails?.attention;

      //standardCartDetails.orderContactData.salesRepEmail = 'asagent@sanofi.com'; //hardcoded for testing
      // if(standardCartDetails?.shippingAddress?.accountNumber == this.getB2BUid()){
      //   this.shippingAddressOfLocation = standardCartDetails?.shippingAddress;
      // }

      if (standardCartDetails?.shipToParty) {
        this.shippingAddressOfLocation =
          standardCartDetails?.shipToParty?.shippingAddresses.filter(
            (item) => item.accountNumber === standardCartDetails.shipToParty.uid
          );
        this.shippingAddressOfLocation = _.first(
          this.shippingAddressOfLocation
        );
      } else {
        if (
          standardCartDetails?.shippingAddress?.accountNumber ==
          this.getB2BUid()
        ) {
          this.shippingAddressOfLocation = standardCartDetails?.shippingAddress;
        }
      }

      //extra thing added for confirmation page
      if (standardCartDetails?.deliveryHours) {
        this.delHrs = standardCartDetails?.deliveryHours;
      }
      this.productEntries = standardCartDetails?.entries;
      //Filtering hideRow as false entries (for splitting scenario)
      this.productEntries = this.productEntries?.filter(
        (element) =>
          element?.quantityStatus != 'Cancelled' &&
          !(element?.hideRow && element?.quantityStatus == 'TBD')
      );
      this.productEntries.map((entry) => {
        entry.pcode = entry.product.code;
      });
      //reservationDetailsEntries not used here as on confirmation page, we cant group data in a table for a product like done in order detail or reservation detail pages.
      const grouped = _.groupBy(this.productEntries, (entry) => entry.pcode);
      this.reservationDetailsEntries.push(grouped);
      this.reservationDetailsProducts = Object.keys(
        this.reservationDetailsEntries[0]
      );
      this.requestedDelDate = standardCartDetails?.requestedDeliveryDate;
      this.shipDelDate = standardCartDetails?.shipDate;
      this.dwnloadAsExcel(); //to prepare excel
      this.ref.detectChanges();
    }
  }

  checkReservationStatus(standardCartDetails) {
    let orderConfirmationDate = standardCartDetails?.orderConfirmationDate;
    let orderConfirmationStatus = standardCartDetails?.orderConfirmationStatus;

    if (this.editReservation) {
      //edit reservation
      this.reservationStatus =
        this.sharedService.getSessionStorage('reservationStatus');
      if (
        this.reservationStatus != 'Confirmed' &&
        orderConfirmationStatus &&
        orderConfirmationStatus != ''
      ) {
        this.reservationStatus = orderConfirmationStatus;
      }
    } else if (this.cancelReservation) {
      //cancelled reservation
      this.reservationStatus = 'Cancelled';
    } else {
      //new reservation
      if (orderConfirmationStatus && orderConfirmationStatus != '') {
        this.reservationStatus = orderConfirmationStatus;
      } else {
        if (
          orderConfirmationDate != undefined ||
          orderConfirmationDate != null
        ) {
          this.reservationStatus = 'Confirmed';
        } else {
          this.reservationStatus = 'Not confirmed';
        }
      }
    }
  }

  capturePaymentInfo(standardCartDetails) {
    let paymentMthod = standardCartDetails?.paymentMethod;
    if (paymentMthod && paymentMthod !== '') {
      //for bill me later
      if (paymentMthod?.toLowerCase()?.startsWith('bill')) {
        this.cardDetails = '';
      } else {
        //For cards/accounts
        let cardNumber = standardCartDetails?.paymentInfo?.cardNumber;
        let cardType = standardCartDetails?.paymentInfo?.cardType?.code;
        if (cardType == 'EC') {
          cardType = 'Account';
        }
        this.cardDetails = `${cardType} ending in ${cardNumber?.substring(
          6,
          10
        )}`;
      }
    }
  }

  validateFaxNumber(event, type, i) {
    // if (fxNmbr == '' || fxNmbr.length != 12) {
    //   this.faxNumberError = true;
    // }
    // else {
    //   this.faxNumberError = false;
    // }
    // this.POnameEdited = true;
    if (event.target.value == '' || event.target.value.length < 10) {
      if (type == 'phone') {
        // this.phoneErrorMsg = true;
      }
      if (type == 'fax') {
        // this.faxErrorMsg = true;
      }
    } else {
      //debugger
      if (type == 'phone') {
        // this.phoneErrorMsg = false;
      }
      if (type == 'fax') {
        // this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      let newVal = event.target.value.replace(/\D/g, '');
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= NumberThree) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= NumberSix) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal.length <= NumberTen) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      } else {
        newVal = newVal.substring(0, NumberTen);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;
      if (type == 'phone') {
        for (var j = 0; j < this.emailMobile.length; j++) {
          if (j == i) {
            this.emailMobile[i].value = newVal;
          }
        }
      }
      if (type == 'fax') {
        this.contactDetails.contactFax = newVal;
      }
      // this.ordersList.forEach(el => {
      //   if (el.fluContactId == id) {
      //     if (type == 'phone') {
      //       el.phoneNo = newVal;
      //     }
      //     else {
      //       el.fax = newVal;
      //     }
      //   }
      // })
    }
  }
  editContactmethod() {
    this.editContact = true;
  }
  changeContactname() {
    this.ContactnameEdited = true;
  }
  getEmailDrpDwnVal(eventValue) {
    if (eventValue.$ngOptionLabel == 'Add new email') {
      this.newemail = true;
    } else {
      this.newemail = false;
    }
    this.ContactnameEdited = true;
  }
  changeColor() {
    const el: any = document.getElementsByClassName('ng-option-label');

    if (el.length) {
      el[el.length - 1].style.color = '#AA1396';
    }
  }

  getImage(images: any, imgFormat: string): string {
    // 'thumbnail'
    const imagesFormat = _.clone(_.findWhere(images, { format: imgFormat }));
    let finalImageUrl: string;
    if (imagesFormat) {
      finalImageUrl = `${this.baseUrl}${imagesFormat?.url}`;
    } else {
      if (this.baseSiteId == 'vsh') {
        finalImageUrl = '../../assets/i18n-assets/sanofi_missing_product.jpg';
      } else {
        finalImageUrl =
          '../../assets/i18n-assets/sanofi_missing_product_vax.jpg';
      }
      //finalImageUrl=this.fallbackImage;
    }
    return finalImageUrl;
  }

  backToDashBoard() {
    //No popup required in confirmation page,directly redirect
    this.sharedService.removeSessionStorage('fluOrderDtls');
    this.router.goByUrl('influenza/dashboard');
  }

  OnFluPrint() {
    window.print();
  }

  closePopup() {
    this.modalService.dismissAll();
  }

  togglePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
    }
    if (this.currentPopover.isOpen()) {
      this.currentPopover.close();
    } else {
      this.currentPopover.open();
    }
  }

  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.activeSeasonSub?.unsubscribe();
    this.fluProductsSubs?.unsubscribe();
    this.getCartsApiSubscriber?.unsubscribe();
    this.cartCheckoutSub?.unsubscribe();
    this.userAccountDetailsSubscriber?.unsubscribe();
    this.contactDetailsSub?.unsubscribe();
    this.placeOrderSub?.unsubscribe();
    this.sharedService.removeSessionStorage('fluData');
  }

  //Methods for reserve contact
  EditValFunc(e) {
    this.editDeliveryHrs = e;
  }

  triggerFunc(e: any) {
    this.delHrs = e;
  }
  editPO() {
    this.editPo = true;
  }
  closeEdit() {
    //this.editPo = this.editContact = false;
    location.reload();
  }
}
